module.exports = __webpack_public_path__ + "assets/images/premium-circle-fab38c10570b0b6369db8a1269105536.png";